import React, { useState } from "react";
import { format, parseISO } from "date-fns";
import { de, enUS, tr, ar } from "date-fns/locale";
import { Calendar as CalendarIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useI18n } from "@/i18n/I18nContext";

const LOCALES = { de, en: enUS, tr, ar };

// Localized date picker. Displays dd.MM.yyyy but emits an ISO yyyy-MM-dd string.
export function DatePicker({ value, onChange, testId }) {
  const { t, lang } = useI18n();
  const [open, setOpen] = useState(false);
  const locale = LOCALES[lang] || enUS;
  const selected = value ? parseISO(value) : undefined;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          className="flex h-12 w-full items-center gap-2 rounded-xl border border-input bg-background px-3 text-left text-sm transition-colors hover:border-[#C4DFD2]"
        >
          <CalendarIcon size={16} className="text-[#7A9488]" />
          <span className={selected ? "text-[#1A2E26]" : "text-[#B0C2B8]"}>
            {selected ? format(selected, "dd.MM.yyyy", { locale }) : t("caseForm.dueDatePlaceholder")}
          </span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto p-0">
        <Calendar
          mode="single"
          selected={selected}
          locale={locale}
          defaultMonth={selected}
          onSelect={(d) => {
            onChange(d ? format(d, "yyyy-MM-dd") : "");
            setOpen(false);
          }}
        />
      </PopoverContent>
    </Popover>
  );
}
